import { useQuery } from "@/api/swr/useQuery";
import { certificateSchema } from "@/schema/Certificate";

type Config = Parameters<typeof useQuery<typeof certificateSchema>>[2];

export function useGetCertificate(id: string, config?: Config) {
  return useQuery(
    certificateSchema,
    `/console/certifications/${id}/certificate`,
    config,
  );
}
